import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import boudoirPilatesFemale1829Webp from '@/assets/landing/boudoir-pilates-female/18-29.webp'
import boudoirPilatesFemale3039Webp from '@/assets/landing/boudoir-pilates-female/30-39.webp'
import boudoirPilatesFemale4049Webp from '@/assets/landing/boudoir-pilates-female/40-49.webp'
import boudoirPilatesFemale50Webp from '@/assets/landing/boudoir-pilates-female/50.webp'

const schema: LandingScreenSchema = {
	order: ['LandingLanguageButton', 'LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-Day Boudoir <br/> Pilates PLAN',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: $t('female_activity.pages.landing.step_1.options.18_29'),
					img: boudoirPilatesFemale1829Webp,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: $t('female_activity.pages.landing.step_1.options.30_39'),
					img: boudoirPilatesFemale3039Webp,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_activity.pages.landing.step_1.options.40_49'),
					img: boudoirPilatesFemale4049Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_activity.pages.landing.step_1.options.50'),
					img: boudoirPilatesFemale50Webp,
				},
			],
		}),
	},
}

export default schema
